var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skill-icon"},[_c('div',{staticClass:"skill",style:(("background:url(" + (_vm.iconData.url) + ") -" + (_vm.iconData.x) + "px -" + (_vm.iconData.y) + "px"))})])}
var staticRenderFns = []

export { render, staticRenderFns }